export type TypeAttrValue = string | number | boolean | null | undefined;

// ----------------------------------------------------------------------------

function setAttr(element: HTMLElement, key: string, value: TypeAttrValue): void {
    if (value === null || value === undefined) {
        element.removeAttribute(key);
        return;
    }

    let attrValue: string;

    if (value === true) {
        attrValue = 'true';
    } else if (value === false) {
        attrValue = 'false';
    } else if (typeof value === 'string') {
        attrValue = value;
    } else {
        attrValue = value.toString();
    }

    element.setAttribute(key, attrValue);
}

// ----------------------------------------------------------------------------

export default setAttr;
